// packages import
import { FC, useContext } from 'react'
import { Box } from '@mui/material'

import { AccountsReceivableContext } from '../../../../context/AccountsReceivableContext'
import { CardBox } from '../../../../theme/styleComponents'
import { ContentHead } from '../../../../components/common/ContentHead'
import AccountsReceivableFilters from '../../../../components/accounting/accountsReceivable/filters'
import { flexCenter } from '../../../../theme/styleConstants'
import { EmptyData } from '../../../../components/common/EmptyData'
import { AccountsReceivableListing } from '../../../../components/accounting/accountsReceivable/AccountsReceivableListing'
import AccountsReceivableSummary from '../../../../components/accounting/accountsReceivable/AccountsReceivableSummary'
import DateRangeFilter from '../../../../components/common/DateRangeFilter'

const AccountsReceivable: FC = () => {
  const { filters, setFilters, arEntries, loading, refetch } = useContext(AccountsReceivableContext)

  const isEmpty = arEntries?.length === 0 && !loading

  const handleStartDateChange = (date: string) => {
    setFilters({ startDate: date || undefined })
  }

  const handleEndDateChange = (date: string) => {
    setFilters({ endDate: date || undefined })
  }

  return (
    <>
      <ContentHead
        title="Accounts Receivable"
        customButton={() => (
          <DateRangeFilter
            fromDate={filters.startDate || null}
            toDate={filters.endDate || null}
            onFromDateChange={handleStartDateChange}
            onToDateChange={handleEndDateChange}
            size="medium"
          />
        )}
        sx={{ bgcolor: 'white', border: 'none' }}
      />

      <AccountsReceivableSummary />

      <CardBox>
        <AccountsReceivableFilters />

        {isEmpty ? (
          <Box sx={{ ...flexCenter, height: 'calc(100vh - 400px)' }}>
            <EmptyData title="No accounts receivable found" />
          </Box>
        ) : (
          <AccountsReceivableListing arEntries={arEntries} loading={loading} refetch={refetch} />
        )}
      </CardBox>
    </>
  )
}

export default AccountsReceivable
